var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalcony(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21 47.656h-11.594c-0.875 0-1.5625 0.69922-1.5625 1.5625v34.883h-1.5625c-0.875 0-1.5625 0.69922-1.5625 1.5625v6.3984c0 0.86328 0.6875 1.5625 1.5625 1.5625h87.5c0.84375 0 1.5625-0.69922 1.5625-1.5625v-6.3984c0-0.86328-0.71875-1.5625-1.5625-1.5625h-1.5625v-34.883c0-0.86328-0.71875-1.5625-1.5625-1.5625h-11.625v-39.719c0-0.86328-0.71875-1.5625-1.5625-1.5625h-54.906c-0.84375 0-1.5625 0.69922-1.5625 1.5625zm69.625 39.57h1.5938v3.2734h-84.375v-3.2734zm-1.5312-36.445h-10.062v33.32h10.062zm-78.125 0v33.32h10.031v-33.32zm40.625 0v33.32h10.594v-33.32zm13.719 0v33.32h10.594v-33.32zm-41.188 0v33.32h10.594v-33.32zm13.719 0v33.32h10.625v-33.32zm-13.719-3.125h24.344v-38.156h-24.344zm27.469-38.156v38.156h24.312v-38.156z",
    fill: "#003102",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalcony);
export default __webpack_public_path__ + "static/media/balcony.17816868.svg";
export { ForwardRef as ReactComponent };